import { ChallengeI18n } from "@/locales/base.message.locales";

export const challenge: ChallengeI18n = {
  prizes: "Prizes",
  loading: "Loading challenges...",
  lives_changed: "{0} Lives will be changed",
  registration_time_to_end: "Time left to enter",
  time_to_end: "Time left to end challenge",
  registration_end: "Enter",
  registration_end_in_days: "Enter - End {0}",
  registration_never_end: "Enter - End in {0} days",
  never_end: "Enter",
  ending_in: "End {0}",
  ending_in_days: "End in {0} day | End in {0} days",
  closed: "Closed",
  users: "{count} User | {count} Users",
  title: "Challenges",
  enter_now: "Enter now",
  challenge_ended: "Challenge ended",
  labels: {
    team_enabled: "Teams enabled",
    no_challenge_registered: "No challenge registered",
    no_challenge_registered_with_tag: 'No challenge registered with tag "{0}"',
    no_challenges_in_progress: "No challenges in progress",
    no_challenges_in_progress_with_tag: 'No challenges in progress with tag "{0}"',
    no_challenges_finished: "No challenges finished",
    no_challenges_finished_with_tag: 'No challenges finished with tag "{0}"',
    no_challenges_comming_soon: "No challenges comming soon",
    no_challenges_comming_soon_with_tag: 'No challenges comming soon with tag "{0}"',
    locale_with_same_problem: "Location with same problem",
    show_map: "Show Map",
    show_users: "Show users",
    you_are_participating: "You are participating",
    signin_to_follow: "Sign in to follow this challenge"
  },
  subtitles: {
    you_area_facing_this_problem: "Enter the location on the box bellow or tag it directly on the map"
  },
  buttons: {
    abort: "Decline",
    accept: "Accept",
    send_locale: "Send Location",
    sign_in: "Log-in",
    skills: "Skills",
    report_problem: "Report problem"
  },
  titles: {
    accept_this_challenge: "Do you want to accept this challenge?",
    you_area_facing_this_problem: "Is your area facing this challenge?",
    follow_challenge: "Do you want to follow this challenge?",
    by: "By"
  },
  messages: {
    no_files: "Oops! We couldn't found any file for this challenge.",
    no_gallery: "Oops! We couldn't found any image gallery for this challenge.",
    add_images: "Add images to the challenge right now !",
    no_tasks: "Oops! We couldn't found any tasks for this challenge.",
    register_task: "Register a task right now !",
    location_failed: "Sorry, some error occurrence when try to send your location",
    location_send: "Location send with success! Thanks for your contribution",
    related_not_founded: "Oops! We couldn't found any challenges.",
    no_challenge_forum: "Oops! We couldn't found any active topic for this challenge.",
    no_challenge_judge: "Oops! We couldn't found any judges for this challenge.",
    no_challenge_partner: "Oops! We couldn't found any partners for this challenge.",
    no_challenge_team: "Oops! We couldn't found any teams for this challenge.",
    no_challenge_advisers: "Oops! We couldn't found any advisers for this challenge.",
    be_a_adviser: "Be a adviser right now !",
    create_team: "Create a team right now !",
    be_a_judge: "Be a judge right now !",
    create_topic: "Create a new topic now !",
    try_reload: "Try reloading the page.",
    server_error: "Oops! Something went wrong with our server.",
    interact_now: "Log in and start interacting right now !",
    problem_location_failed: "Oops! The location could not be sent."
  },
  tab_titles: {
    teams: "Teams",
    my_team: "My Team",
    timeline: "Timeline",
    advisers: "advisory board",
    faq: "FAQ",
    map: "challenge map",
    judges: "judges",
    tasks: "Tasks",
    in_progress: "In progress",
    finished: "Finished",
    coming_soon: "coming soon",
    community: "community",
    all: "All",
    gallery: "Image Gallery",
    files: "Files",
    partners: "Partners"
  },
  challenges_title: "Active Challenges",
  challenges_finished: "Results",
  description: "Description",
  upload_file: "Upload file",
  related: "Related Challenges",
  judges: "{count} Judge | {count} Judges",
  not_judges: "No related judges yet",
  advisers: "{count} Adviser | {count} Advisers",
  partners: "{count} HomePartner | {count} Partners",
  advisers_description: "Adviser does not have additional information.",
  judge_description: "Judge does not have additional information.",
  impactedSDGs: "SDGs impacted by the challenge",
  knowMoreAboutSDGs: "KNOW MORE ABOUT THE 17 UN SDGs",
  not_advisers: "No advisers selected yet",
  type: {
    competition: "Competition",
    collaborative: "Collaborative"
  },
  accept: {
    button: "",
    text:
      "Be a member of Ikone – Global Social League – Your work and talent will become the solutions that the world needs.",
    title: "I ACCEPT CHALLENGES"
  },
  have: {
    button: "",
    text: "Share your perceptions with Ikone – Global Social League – A complex and life changing challenge.",
    title: "I HAVE A CHALLENGE",
    long_description: `Many challenges are too complex to solve alone.<br/> If you, like us, believe in the power of acting together and in cooperation, send us a message with details about the challenge you want to solve.`
  },
  actions: {
    abort: "Abort Mission",
    accept: "Accept Challenge"
  },
  follow: {
    success: "Success! You’re now following this Challenge!",
    error: "Oops! Something went wrong."
  },
  unfollow: {
    success: "Success! You’re no longer following this Challenge!",
    error: "Oops! Something went wrong."
  },
  dialog: {
    no_profile_accept: "To accept challenges you need to create your contestant profile.",
    no_profile_follow: "To follow challenges you need to create your contestant profile.",
    redirect: "You will be redirect to your profile configuration page.",
    accept: {
      title: "Accept challenge?",
      text: "You will follow all activities in this challenge.",
      button: "Accept"
    },
    abort: {
      title: "Abort Mission?",
      text: "You will lose all your activities in this challenge.",
      button: "Abort"
    },
    post: {
      name: "Name*",
      email: "E-mail*",
      phone: "Phone*",
      country: "Country*",
      category: "Category suggestion*",
      message: "Describe your challenge*",
      button: "Send"
    }
  },
  search_results: "Search Results:"
};
